package pl.michal_cyran.brand_hub.components.layouts

import pl.michal_cyran.brand_hub.components.sections.NavHeader


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.dom.svg.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssRule
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.theme.SilkTheme
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.css.vh
import pl.michal_cyran.brand_hub.components.sections.Footer
import pl.michal_cyran.brand_hub.toSitePalette

val PageContentStyle = CssStyle {
    base { Modifier.fillMaxSize() }
    Breakpoint.MD { Modifier.fillMaxWidth() }

//    cssRule("body") {
//        Modifier
//            .backgroundColor(
//                colorMode.toSitePalette().background
//            )
//    }
}



class PageLayoutData(val title: String)

@Composable
@Layout
fun PageLayout(ctx: PageContext, content: @Composable ColumnScope.() -> Unit) {
    val data = ctx.data.getValue<PageLayoutData>()
    LaunchedEffect(data.title) {
        document.title = data.title
    }
    Column(
        Modifier.fillMaxSize().gridRow(1),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        NavHeader()
        Div(PageContentStyle.toAttrs()) {
            content()
        }
        Footer()
    }
}
